import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import AppContext from 'context/Context';
import { generateExportLog } from 'api/endpoints/Export';
import { useState } from 'react';

const CardDropdown = ({
  btnRevealClass,
  drop,
  children,
  icon = 'ellipsis-v',
  onView, // Parent function for View action
  onExport, // Parent function for Export action
  onExportAll,
  onRemove, // Optional: Parent function for Remove action (if needed)
  showColumnVisiblity,
  toggleFilters,
  exportKey
}) => {
  const {
    config: { isRTL }
  } = useContext(AppContext);

  const [exporting, setExporting] = useState(false);

  const handleAllExport = async () => {
    if (!exportKey) {
      return;
    }
    setExporting(true);
    try {
      const response = await generateExportLog(exportKey, {});
      if (response) {
        window.open('/ExportReportsPage', '_blank');
      }
    } catch {
      setExporting(false);
    }
  };

  const handleView = () => {
    if (onView) onView(); // Call the onView function passed from the parent
  };

  const handleExport = () => {
    if (onExport) onExport(); // Call the onExport function passed from the parent
  };

  const handleExportAll = () => {
    if (onExportAll) onExportAll(); // Call the onExportAll function passed from the parent
  };

  const handleRemove = () => {
    if (onRemove) onRemove(); // Call the onRemove function passed from the parent
  };

  return (
    <Dropdown
      className="font-sans-serif btn-reveal-trigger d-none d-sm-block"
      align={isRTL ? 'start' : 'end'}
      drop={drop}
    >
      <Dropdown.Toggle
        variant="link"
        size="sm"
        data-boundary="viewport"
        className={classNames('text-600', {
          [btnRevealClass]: btnRevealClass,
          'btn-reveal': !btnRevealClass
        })}
      >
        <FontAwesomeIcon icon={icon} className="fs--2" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="border py-0">
        {children ? (
          children
        ) : (
          <div className="py-2">
            {/* <Dropdown.Item onClick={handleView}>View</Dropdown.Item> */}
            {toggleFilters && (
              <Dropdown.Item onClick={toggleFilters}>
                Column Filter
              </Dropdown.Item>
            )}
            {showColumnVisiblity && (
              <Dropdown.Item onClick={() => showColumnVisiblity(true)}>
                Col. Show/Hide
              </Dropdown.Item>
            )}
            <Dropdown.Divider />
            <Dropdown.Item onClick={handleExport}>Export</Dropdown.Item>
            {/* {onExportAll && (
              <Dropdown.Item onClick={handleExportAll}>
                Export All
              </Dropdown.Item>
            )} */}
            {/* <Dropdown.Item onClick={handleAllExport}>Export All</Dropdown.Item> */}
            {exportKey && (
              <Dropdown.Item onClick={handleAllExport}>
                Export All
              </Dropdown.Item>
            )}
            {/* <Dropdown.Item className="disabled">Export All</Dropdown.Item> */}
            {/* Optional Remove item */}
            {onRemove && <Dropdown.Divider />}
            {onRemove && (
              <Dropdown.Item className="text-danger" onClick={handleRemove}>
                Remove
              </Dropdown.Item>
            )}
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

CardDropdown.propTypes = {
  btnRevealClass: PropTypes.string,
  drop: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.string,
  onView: PropTypes.func, // Function passed from parent for the View action
  onExport: PropTypes.func, // Function passed from parent for the Export action
  onExportAll: PropTypes.func, // Function passed from parent for the Export action
  onRemove: PropTypes.func, // Optional function passed from parent for the Remove action
  showColumnVisiblity: PropTypes.func, // Optional function passed from parent for the Remove action
  toggleFilters: PropTypes.func, // Optional function passed from parent for the Remove action
  exportKey: PropTypes.string
};

export default CardDropdown;
